// extracted by mini-css-extract-plugin
module.exports = {"title":"FeaturePageHeader_title__HhZtm","subtitle":"FeaturePageHeader_subtitle__b7Y8w","description":"FeaturePageHeader_description__P8TD4","cta":"FeaturePageHeader_cta__9SpWC"};